module.exports = __webpack_public_path__ + "media/honey-icons/icon-logout-3fb379bd.svg";